// @flow

import updateValuationItemAmount from '../../../Services/updateValuationItemAmount';
import type { UpdateValuationItemAmountParams } from '../../../types';

export default (params: UpdateValuationItemAmountParams) => async (dispatch: Function) => dispatch(updateValuationItemAmount(params));